export { default } from './CardGalleryItem';
